export { default as IncentiveDetails } from './incentive-details';
